<section class="page">
  <div class="header-container separator">
    <div class="header">{{'VIEW.MAIN.MAIN.DOCTORS' | translate}}</div>
    <div class="actions">
<!--      <button type="button" class="btn btn-primary"-->
<!--              (click)="export()"> {{ 'COMMON.EXPORT' | translate}} </button>-->
    </div>
  </div>

  <div class="content">
    <app-data-grid *ngIf="data" [data]="data.content"
                   [criteria]="criteria"
                   [context]="{ host: this }"
                   [selectionEnabled]="false"
                   [showFilters]="true"
                   [showSearch]="true"
                   [showPagination]="true"
                   [pageTotal]="data.totalPages" [itemTotal]="data.totalElements"
                   (criteriaChanged)="onCriteriaChanged($event)"
                   [columns]="$any([
                    { colId: '1', headerName: ('VIEW.MAIN.DOCTOR.DATA.JOIN_DATE' | translate), maxWidth: 100, field: 'joinDate', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: joinDateTemplate, preventSelection: false } },
                    { colId: '2', headerName: ('VIEW.MAIN.DOCTOR.DATA.STATUS' | translate), maxWidth: 100, field: 'status', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: statusTemplate, preventSelection: false } },
                    { colId: '3', headerName: ('VIEW.MAIN.DOCTOR.DATA.CUSTOMER_ID' | translate), maxWidth: 120, field: 'customerId', suppressSizeToFit: true },
                    { colId: '4', headerName: ('VIEW.MAIN.DOCTOR.DATA.FIRST_NAME' | translate), maxWidth: 130, field: 'firstName', suppressSizeToFit: true },
                    { colId: '5', headerName: ('VIEW.MAIN.DOCTOR.DATA.LAST_NAME' | translate), maxWidth: 130, field: 'lastName', suppressSizeToFit: true },
                    { colId: '6', headerName: ('VIEW.MAIN.DOCTOR.DATA.SPECIALITY' | translate), maxWidth: 150, field: 'speciality', overrideSortField: 'specialities', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: specialityTemplate, preventSelection: false } },
                    { colId: '7', headerName: ('VIEW.MAIN.DOCTOR.DATA.PHONE_NUMBER' | translate), maxWidth: 135, field: 'phoneNumber', suppressSizeToFit: true },
                    { colId: '8', headerName: ('VIEW.MAIN.DOCTOR.DATA.RATING' | translate), maxWidth: 90, field: 'rating', suppressSizeToFit: true, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: ratingDataTemplate, preventSelection: false } },
                    { colId: '9', headerName: ('VIEW.MAIN.DOCTOR.DATA.EMAIL' | translate), minWidth: 150, flex: 1, field: 'email', cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: emailTemplate, preventSelection: false } },
                    { colId: '10', headerName: ('COMMON.ACTIONS' | translate), headerClass: 'header-right', cellClass: 'cell-right', sortable: false, minWidth: 150, cellRendererFramework: DataGridTemplateCellRendererComponent, cellRendererParams: { ngTemplate: menuTemplate, preventSelection: false } },
                  ])">

      <app-data-grid-filters>
        <div class="filter">
          <ng-select name="filter-status"
                     class="sm"
                     [placeholder]="'VIEW.MAIN.DOCTOR.FILTER.STATUS.PLACEHOLDER' | translate"
                     [searchable]="false"
                     [(ngModel)]="criteria.status" (ngModelChange)="onStatusFilterChanged($event)">
            <ng-option *ngFor="let status of statuses"
                       [value]="status">{{ status | prefix:'ENUM.DOCTOR_STATUS.' | translate }}</ng-option>
          </ng-select>
        </div>
      </app-data-grid-filters>
    </app-data-grid>
  </div>
</section>

<!--Templates-->
<ng-template #statusTemplate let-value="value">
  <ng-container [ngSwitch]="value">
    <ng-container *ngSwitchCase="DoctorStatus.ACTIVE">
      <span class="color-primary">{{value | prefix: 'ENUM.DOCTOR_STATUS.' | translate }}</span>
    </ng-container>
    <ng-container *ngSwitchCase="DoctorStatus.INACTIVE">
      <span class="color-gray-3">{{value | prefix: 'ENUM.DOCTOR_STATUS.' | translate }}</span>
    </ng-container>
    <ng-container *ngSwitchDefault>-</ng-container>
  </ng-container>
</ng-template>

<ng-template #joinDateTemplate let-value="value">
  <span *ngIf="value;else noDataTemplate">{{value | date:Constant.DATE_FORMAT}}</span>
</ng-template>

<ng-template #emailTemplate let-value="value">
  <a *ngIf="value; else noDataTemplate" href="mailto:{{value}}">{{value}}</a>
</ng-template>

<ng-template #specialityTemplate let-value="value">
  <span>{{value?.name}}</span>
</ng-template>

<ng-template #menuTemplate let-data>
  <button type="button"
          class="btn btn-link text-normal btn-link--black font-size-sm"
          (click)="goDetails(data)">{{'COMMON.SHOW_DETAILS' | translate}}</button>
</ng-template>

<ng-template #ratingDataTemplate let-value="value">
  <span *ngIf="value;else noDataTemplate">{{value | number : '1.1'}}</span>
</ng-template>

<ng-template #noDataTemplate>
  <span>-</span>
</ng-template>

